import { Button, message, Modal, Select, Spin } from 'antd'
import React from 'react'
import { CustomRow, CustomCol } from '../../components/Custom';
import DetailTitle from '../../components/DetailTitle';
import FileUpload_JR from "../../components/FileUpload_JR";
import { Row,Col,Form, Input } from "antd";
import { post } from '../../axios';
import { houseTypeLabelMap } from '../../axios/dictionaries';

import { API_salesroom_create, API_salesroom_edit, API_salesroom_getById, API_building_findBuildingList } from '../../axios/config';

class SalesroomDetail extends React.Component{
  state = {
    id: null,
    visible: false,
    buildingList: [],
    dataLoading: false,
    submitLoading: false,
    isInfo:false
  }
  open(id = null,isInfo=false) {
    this.setState({ visible: true, id ,isInfo:isInfo})
    if (id) {
      this.postSalesroomGet(id)
    }
    this.postBuildingList()

    return new Promise((resolve,reject) => {
      this.monitor = { resolve, reject }
    })
  } 
  close() {
    this.setState({ visible: false })
    this.props.form.resetFields()
    this.fileUploadRef_attachIds.set([])
    this.fileUploadRef_coverPicture.set([])
  }
  renderFooter() {
    return (
      <div className="app-modal-footer">
        {!this.state.isInfo&&<Button type="primary" onClick={this.handleSubmit.bind(this)} loading={this.state.submitLoading}>保存</Button>}
        <Button onClick={this.close.bind(this)}>取消</Button>
      </div>
    )
  }
  postBuildingList() {
    post({ url: API_building_findBuildingList }).then(res => {
      this.setState({ buildingList: res })
    })
  }
  postSalesroomSubmit(data) {
    const url = data.id ? API_salesroom_edit : API_salesroom_create
    this.setState({ submitLoading: true })

    return post({ url, data }).then(res => {
      //this.setState({ submitLoading: false })
    }).finally(() => {
      this.setState({ submitLoading: false })
    })
  }
  postSalesroomGet(id) {
    this.setState({ dataLoading: true })
    post({ url: API_salesroom_getById + '?id=' + id }).then(res => {
      this.props.form.setFieldsValue({
        projectName: res.projectName,
        serviceTel: res.serviceTel,
        buildingId: res.buildingId,
        displayLabel: res.displayLabel ? res.displayLabel.split(','): [],
      })
      this.fileUploadRef_coverPicture.set(res.coverPicture)
      this.fileUploadRef_attachIds.set(res.projectImages)
     // this.setState({ dataLoading: false })
    }).finally(() => {
      this.setState({ dataLoading: false })
    })
  }
 

  handleSubmit() {
    this.props.form.validateFields((err, values) => {
      if (err) return
      values.id = this.state.id || undefined
      values.attachIds = this.fileUploadRef_attachIds.get().map(e => e.id)
      values.displayLabel = values.displayLabel.join(',')

      const coverPicture = this.fileUploadRef_coverPicture.get()[0]
  
      if(!coverPicture) return message.warning('请上传门店封面')
      if (values.attachIds.length ===0) return message.warning('请上传介绍图片')
      values.coverPicture = coverPicture.attach_url || coverPicture
      values.jrCoverPicture = coverPicture.jr_attach_url
   
      
      this.postSalesroomSubmit(values).then(() => {
        this.close()
        this.monitor.resolve()
        message.success('保存成功')
      }).catch((e) => {
        message.error(e.message)
      })
    })
  }
  render(){
    const modalConfig = {
      title: this.state.id ? '编辑门店' : '新增门店',
      visible: this.state.visible,
      footer: this.renderFooter(),
      width: 642,
      onCancel: () => this.close()
    }
    const { getFieldDecorator, getFieldValue } = this.props.form
    const labelWidth = 100
    const labelValue = getFieldValue('displayLabel')
    return (
      <Modal {...modalConfig}>
        <Spin spinning={this.state.dataLoading}>
          <div className="custom" style={{padding: 20}}>
            <Form  labelCol={{ span: 0 }} wrapperCol={{ span: 24 }}>
              <Row>
                <Col span={24}>
                  <DetailTitle title="基本信息" boxStyle={{ marginTop: '0' }} />
                  <CustomRow >

                    <CustomCol labelStyle={{ width: labelWidth }} label="门店名称">
                        {getFieldDecorator('projectName', {
                            rules: [{ required: true, message: '请输入门店名称', }],
                        })(
                            <Input
                                placeholder={'请输入'}
                                autoComplete={'off'}
                            />
                        )}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} label="所属楼栋">
                        {getFieldDecorator('buildingId', {
                            rules: [{
                                required: true, message: '请选择所属楼栋',
                            }],
                        })(
                          <Select>
                            {this.state.buildingList.map(e => (
                              <Select.Option key={e.id} value={e.id}>{e.name}</Select.Option>
                            ))}
                          </Select>
                        )}
                    </CustomCol>
                  </CustomRow>
                  <CustomRow divider>

                    <CustomCol labelStyle={{ width: labelWidth }} label="门店电话">
                        {getFieldDecorator('serviceTel', {
                            rules: [{ required: true, message: '请输入门店电话', }],
                        })(
                            <Input
                                placeholder={'请输入'}
                                autoComplete={'off'}
                            />
                        )}
                    </CustomCol>
                  </CustomRow>
                  <CustomRow divider>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{width: 500}} label="推荐标签">
                      {getFieldDecorator('displayLabel', {
                          rules: [{
                              required: true, message: '请选择推荐标签',
                          }],
                      })(
                        <Select
                            mode="multiple"
                            tokenSeparators={[',']}
                            placeholder="请选择(最多选择3个)"
                        >
                          {
                            labelValue && labelValue.length >= 3 ?
                            [] :
                            houseTypeLabelMap.map((item, index) => <Select.Option key={ item.value } value={ item.value }>{ item.title }</Select.Option>)
                          }
                        </Select>
                      )}
                    </CustomCol>
                    
                  </CustomRow>
                
                  <DetailTitle title="门店照片" />
                  <FileUpload_JR ref={(ref) => this.fileUploadRef_coverPicture = ref}   />
                  <DetailTitle title="介绍图片" />
                  <FileUpload_JR ref={(ref) => this.fileUploadRef_attachIds = ref}  count={5}  attachType={15} />
                </Col>
              </Row>
            </Form>
          </div>
        </Spin>
      </Modal>
    )
  }
}

export default Form.create({ wrappedComponentRef: true })(SalesroomDetail) 


// WEBPACK FOOTER //
// ./src/page/Salesroom/detail.jsx